import React from 'react';
import styles from './Header.scss';

const ICICIBankLogo = () => (
  <div className={styles['bank-logo']}>
    <span className={styles['bank-logo-text']}>
      <span className={styles['bank-logo-icici']}>ICICI</span>
      <span className={styles['bank-logo-bank']}>Bank</span>
    </span>
  </div>
);

const SafeKeyLogo = () => (
  <div className={styles['safekey-logo']}>
    <img
      className={styles['amex-icon']}
      src="https://www.americanexpress.com/favicon.ico"
      alt="American Express"
    />
    <span className={styles['safekey-text']}>SafeKey®</span>
  </div>
);

const Header = () => (
  <div className={styles.header}>
    <ICICIBankLogo />
    <SafeKeyLogo />
  </div>
);

export default Header;
